export class IdentityProvidersModel {
    appleSignIn: boolean = false;
    azureSignIn: boolean = false;
    facebookSignIn: boolean = false;
    googleSignIn: boolean = false;
}
